import React from "react";
import Spinner from "../../../../../rent/pages/mortgage-landing-page/components/contact-form/components/loading-button/components/spinner";
import "./index.scss";

export default function Submit({ text, disabled, loading }) {
    return <button disabled={disabled} type="submit" className="submit-button-mort-contact">
        {loading ? <Spinner finishedLoading={!loading}/> : text}
    </button>
}